if (!customElements.get('bundle-widget')) {
  customElements.define(
    'bundle-widget',
    class BundleWidget extends HTMLElement {
      constructor() {
        super();
        this.button = this.querySelector('.bundle-add-to-cart');
        const DELAY = 1000;
        document.addEventListener('mulberry-shopify:loaded', () => {
          setTimeout(this.enableButton.bind(this), DELAY);
        });
      }

      enableButton() {
        if (!this.button) return;
        this.button.classList.remove('loading');
        this.button.removeAttribute('disabled');
        this.loadingOverlay =  this.button.querySelector('.loading-overlay__spinner');
        if(this.loadingOverlay) {
          this.loadingOverlay.classList.add('hidden');
        }
      }
    },
  );
}
